


















import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Cell } from '@/main/utils/table';

import { NAME } from './constants';
import { store } from './store/list';
import { types } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
	},
	data() {
		return {
			selectedPracId: null as number | null,
		};
	},
	computed: {
		mutationsMapper(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${types.mutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		createClickFun() {
			openEdit(
				NAME,
				PageMode.CREATE,
				{ props: true, filter: { ...this.filter, PracovnikId: this.selectedPracId ?? this.PracovnikId } },
			);
		},
		currentChange(cells: Cell[]) {
			this.selectedPracId = cells[this.table.cellNames!.PRACOVNIK_ID];
		},
	},
});
